import { copy } from "shared/assets";
import { IFieldType, IFormField } from "shared/types";

export const getFields = ({
  excludeOptions,
}: {
  excludeOptions?: string[];
}): IFormField[] => [
  {
    name: "bandUsers",
    label: copy.authFormFields.selectMembers,
    type: IFieldType.peoplePicker,
    validation: {
      required: copy.errors.required,
    },
    settings: {
      includeUsersFromAllBands: true,
      hideCategories: true,
      excludeOptions,
    },
  },
];
